import { render, staticRenderFns } from "./bs.vue?vue&type=template&id=74a90349"
import script from "./bs.vue?vue&type=script&lang=js"
export * from "./bs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports